import { PieChartCard } from './PieChartCard'
import { withPieChartCard } from './withPieChartCard'

const ConnectedPieChartCard = withPieChartCard(PieChartCard)

export { ConnectedPieChartCard as PieChartCard }
